module.exports = __webpack_public_path__ + "static/img/search.3e8a7f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search.png
// module id = 9uNU
// module chunks = 1